<template>
    <div>
        <div v-if="!loading" class="logout-icon-container">
            <feather-icon
                icon="LogOutIcon"
                svgClasses="w-6 h-6 cursor-pointer"
                @click="$router.push({'name': 'page-logout'})"
            />
            <span class="logout-text" @click="$router.push({'name': 'page-logout'})">Logout</span>
        </div>

        <template v-if="organisation_error">
            <vx-card>
                <h4>You have to come online once, To choose Organisation.</h4>
            </vx-card>
        </template>
        <template v-else>
            <template v-if="loading">
                <div class="mt-base text-center">
                    <font-awesome-icon :icon="loadingIcon" size="3x" class="mb-5" spin />
                    <br/>Loading your organisations.. Please wait..
                </div>
            </template>
            <template v-else>
                <div class="logo mb-3 text-center mt-base">
                    <img :src="require('@/assets/images/logo/logo.png')" alt="logo" style="max-width: 150px; max-height: 75px;">
                </div>
                <h3 class="mt-4 mb-6 text-center text-gray-700">
                    Choose Organisation to continue
                </h3>
                
                <div class="search-container">
                    <div class="search-wrapper" :class="{ 'search-focused': isSearchFocused }">
                        <feather-icon
                            icon="SearchIcon"
                            svgClasses="search-icon"
                        />
                        <vs-input
                            v-model="searchQuery"
                            placeholder="Search organisations..."
                            class="search-input"
                            size="small"
                            :no-border="true"
                            @focus="isSearchFocused = true"
                            @blur="isSearchFocused = false"
                        />
                        <div v-if="searchQuery" class="clear-btn" @click="clearSearch">
                            <feather-icon
                                icon="XIcon"
                                svgClasses="w-6 h-6"
                            />
                        </div>
                    </div>
                </div>
                
                <div class="mx-auto w-full px-5 md:w-3/4 mt-2">
                    <template v-if="filteredOrganisations.length > 0">
                        <vx-card
                            v-for="(organisation, index) in filteredOrganisations"
                            :key="index"
                            @click="load_organisation(organisation)"
                            class="mb-3"
                        >
                            <div class="flex items-center">
                                <div class="flex-1">
                                    <small class="block text-primary" v-if="organisation.parent_organisation">
                                        {{ organisation.parent_organisation.name }} >
                                    </small>
                                    {{ organisation.name }}
                                    <small class="block">{{ organisation.user ? format_role(organisation.user.role) : 'No Access' }}</small>
                                </div>
                                <div class="flex items-center">
                                    <vs-button class="px-2 py-1 round" color="primary" @click="load_organisation(organisation)">
                                        <font-awesome-icon :icon="rightArrowIcon" />
                                    </vs-button>
                                </div>
                            </div>
                        </vx-card>
                    </template>
                    <template v-else-if="searchQuery.trim()">
                        <vx-card class="text-center p-6">
                            <div class="mb-3">
                                <feather-icon
                                    icon="SearchIcon"
                                    svgClasses="w-12 h-12 text-gray-400 mx-auto"
                                />
                            </div>
                            <h4 class="text-gray-600 mb-2">No organisations found</h4>
                            <p class="text-gray-500">Try adjusting your search terms</p>
                        </vx-card>
                    </template>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import { faChevronRight, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { Request } from '../../utils/requests'

export default {
    data() {
        return {
            organisations: [],
            allOrganisations: [],
            loading: true,
            organisation_error: false,
            searchQuery: '',
            isSearchFocused: false,

            roles: [
                {label: 'Admin', value: 'a'},
                {label: 'Staff', value: 's'},
                {label: 'Template Manager', value: 't'},
                {label: 'Subscriber', value: 'c'}
            ]
        }
    },
    computed: {
        loadingIcon: () => faSpinner,
        rightArrowIcon: () => faChevronRight,
        filteredOrganisations() {
            if (!this.searchQuery.trim()) {
                return this.organisations;
            }
            
            const query = this.searchQuery.toLowerCase().trim();
            return this.organisations.filter(org => {
                const orgName = org.name.toLowerCase();
                const parentOrgName = org.parent_organisation ? org.parent_organisation.name.toLowerCase() : '';
                
                return orgName.includes(query) || parentOrgName.includes(query);
            });
        }
    },
    mounted() {
        if (this.$route.query.autoload_organisation) {
            this.auto_load_organisation()
        } else {
            this.init()
        }
    },
    methods: {
        init() {
            if(this.$store.state.is_online) {
                this.load_organisations()
            } else {
                this.load_last_organisation(false)
            }
        },
        auto_load_organisation () {
            Request(this, 'GET', this.$store.state.apiendpoints.user_organisations, {limit: 1, id: this.$route.query.autoload_organisation}).then(
                async(res) => {
                    if (res.results.length) {
                        this.load_organisation(res.results[0])

                    } else {
                        this.init()
                    }
                },
                (err) => {
                    this.init()
                }
            )
        },
        load_organisations() {
            this.loading = true
            Request(this, 'GET', this.$store.state.apiendpoints.user_organisations, {limit: 100,is_active: true}).then(
                async res => {
                    this.organisations = res.results
                    await this.load_last_organisation()
                    this.loading = false
                },
                () => {
                    this.$vs.notify({
                        time: 60000,
                        title: 'Error',
                        text: "Unable to load organisations. Please refresh to try again.",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        load_last_organisation(is_online=true) {
            return new Promise(async (resolve, reject) => {
                if (this.$route.query.force) {
                    return resolve()
                }
                let last_organisation = this.$store.getters['organisation/lastOrganisation']
                let organisation = null
                if (last_organisation != null) {
                    if(is_online) {
                        organisation = this.organisations.find(v => v.id == last_organisation.id)
                    } else {
                        organisation = last_organisation
                    }
                } else if (!is_online) {
                    //for offline
                    this.organisation_error = true
                    return reject()
                }
                if (!organisation) {
                    if (this.organisations.length == 1) {
                        organisation = this.organisations[0]
                    } else {
                        return resolve()
                    }
                }

                this.load_organisation(organisation)
            })
        },
        load_organisation(organisation) {
            this.$store.dispatch('organisation/updateActiveOrganisation', organisation)
            this.$store.dispatch('organisation/updateOrganisationUser', organisation.user)
            this.$router.push(this.$route.query.next || "/")
        },
        format_role(role) {
            let _role =  this.roles.find(v => v.value == role)
            if (!_role) return "Unknown"
            return _role.label
        },
        clearSearch() {
            this.searchQuery = ''
            this.isSearchFocused = false
        }
    }
}
</script>

<style scoped>
.logout-icon-container {
    position: fixed;
    top: 4rem;
    right: 4rem;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.logout-icon-container .logout-text {
    margin-left: 0.5rem;
    font-size: 1.5rem;
    color: #000;
    cursor: pointer;
}

.search-container {
    display: flex;
    justify-content: center;
    margin: 1.5rem auto 2rem auto;
    padding: 0 1rem;
    max-width: 500px;
    width: 100%;
    animation: slideIn 0.4s ease-out;
}

.search-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background: #ffffff;
    border: 2px solid #e9ecef;
    border-radius: 12px;
    padding: 0.75rem 1rem;
    width: 100%;
    max-width: 400px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.search-wrapper:hover {
    border-color: #007bff;
    box-shadow: 0 4px 16px rgba(0, 123, 255, 0.12);
    transform: translateY(-1px);
}

.search-wrapper.search-focused {
    border-color: #007bff;
    background: #ffffff;
    box-shadow: 0 6px 24px rgba(0, 123, 255, 0.15);
    transform: translateY(-2px);
}

.search-icon {
    width: 18px;
    height: 18px;
    color: #6c757d;
    margin-right: 0.75rem;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.search-wrapper.search-focused .search-icon {
    color: #007bff;
    transform: scale(1.05);
}

.search-input {
    flex: 1;
    border: none !important;
    background: transparent !important;
    font-size: 0.95rem;
    color: #495057;
    outline: none;
    font-weight: 400;
}

.search-input::placeholder {
    color: #adb5bd;
    font-size: 0.9rem;
    font-weight: 400;
}

.clear-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    color: #dc3545;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-left: 0.75rem;
    animation: fadeIn 0.2s ease;
    flex-shrink: 0;
}

.clear-btn:hover {
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

.clear-btn:active {
    transform: scale(0.95);
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 768px) {
    .search-container {
        padding: 0 0.75rem;
        margin: 1.25rem auto 1.75rem auto;
    }
    
    .search-wrapper {
        max-width: 100%;
        padding: 0.65rem 0.9rem;
        border-radius: 10px;
    }
    
    .search-icon {
        width: 16px;
        height: 16px;
        margin-right: 0.6rem;
    }
    
    .search-input {
        font-size: 0.9rem;
    }
    
    .search-input::placeholder {
        font-size: 0.85rem;
    }
    
    .clear-btn {
        width: 20px;
        height: 20px;
        margin-left: 0.6rem;
    }
}

@media (max-width: 480px) {
    .search-container {
        padding: 0 0.5rem;
        margin: 1rem auto 1.5rem auto;
    }
    
    .search-wrapper {
        padding: 0.6rem 0.8rem;
        border-radius: 8px;
    }
    
    .search-icon {
        width: 15px;
        height: 15px;
        margin-right: 0.5rem;
    }
    
    .search-input {
        font-size: 0.85rem;
    }
    
    .search-input::placeholder {
        font-size: 0.8rem;
    }
    
    .clear-btn {
        width: 18px;
        height: 18px;
        margin-left: 0.5rem;
    }
}
</style>
